var miscInit;

(function ($) {

	const selectors = {
		scrollTop: '[data-scroll-top]',
	}

	miscInit = function () {

		$(selectors.scrollTop).click(function (e) {
			e.preventDefault();
			$('html, body').stop().animate({ scrollTop: 0 }, 1000);
		})

		$('a[href="#"]').on('click', (e) => { e.preventDefault(); });

		$('a[href^="#"]:not([href="#"])').on('click', function (e) {
			e.preventDefault();

			const target_id = $(this).attr('href').slice(1);
			const $target = $('#' + target_id + ', [data-id="' + target_id + '"]').filter(':visible');

			if ($target.length) {
				$('html, body').stop().animate({ scrollTop: $target.offset().top - 80 }, 1000);
			}

		})

	}

})(jQuery);

export default miscInit;